import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useMembers, MemberAvatar } from "@/lib/members";

const UNASSIGNED = "__unassigned__";

/** DynamicField renderer for the `member` (assignee) field type. */
export function MemberFieldRenderer({ field, value, onChange, error }) {
  const { members } = useMembers();
  return (
    <div data-testid={`field-${field.key}`}>
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <label className="text-sm font-medium">
          {field.label}
          {field.required && <span className="text-destructive ml-1">*</span>}
        </label>
        <span className="text-[10px] font-mono text-muted-foreground uppercase">member</span>
      </div>
      <Select
        value={value || UNASSIGNED}
        onValueChange={(v) => onChange(v === UNASSIGNED ? null : v)}
      >
        <SelectTrigger data-testid={`member-select-${field.key}`}>
          <SelectValue placeholder="Unassigned" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={UNASSIGNED}>
            <span className="text-muted-foreground">Unassigned</span>
          </SelectItem>
          {members.map((m) => (
            <SelectItem key={m.user_id} value={m.user_id}>
              <span className="inline-flex items-center gap-2">
                <MemberAvatar user={m} size={18} />
                {m.name || m.email}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error
        ? <p className="text-xs text-destructive mt-1.5" data-testid={`error-${field.key}`}>{error}</p>
        : field.help_text ? <p className="text-xs text-muted-foreground mt-1.5">{field.help_text}</p> : null}
    </div>
  );
}
